import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useContext, useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { Input, Icon } from '../index';
import { validateColor } from './utils/validateColor';
import { colorTypes } from './constant/colorTypes';
import ColorPickerPanel from './color-picker-panel';
import { colorFormat, strFixed, getColorObj, valOfCorrespondingType, highlightPresetColorIndex, presetColorToHEX } from './utils/colorFormat';
import { toLowerCase } from './utils/convertLetters';
import { defaultSystemColor } from './constant/defaultColor';
import Color from 'color';
import { getCompProps } from '../_utils';
import usePopper from '../_utils/usePopper';
import { systemPresetColor } from './constant/systemPresetColor';
var ColorPicker = function ColorPicker(props) {
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var colorPickerProps = getCompProps('ColorPicker', userDefaultProps, props);
  var value = colorPickerProps.value,
    className = colorPickerProps.className,
    style = colorPickerProps.style,
    functionalColor = colorPickerProps.functionalColor,
    functionalColorName = colorPickerProps.functionalColorName,
    switchName = colorPickerProps.switchName,
    showSwitch = colorPickerProps.showSwitch,
    showColorTransfer = colorPickerProps.showColorTransfer,
    showPresetColor = colorPickerProps.showPresetColor,
    showColorPickerBox = colorPickerProps.showColorPickerBox,
    borderType = colorPickerProps.borderType,
    presetColor = colorPickerProps.presetColor,
    placeholder = colorPickerProps.placeholder,
    defaultValue = colorPickerProps.defaultValue,
    defaultOpen = colorPickerProps.defaultOpen,
    visible = colorPickerProps.visible,
    suffixIcon = colorPickerProps.suffixIcon,
    onChange = colorPickerProps.onChange,
    onVisibleChange = colorPickerProps.onVisibleChange;
  var _useState = useState(defaultValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    inputColorValue = _useState2[0],
    setInputColorValue = _useState2[1];
  var _useState3 = useState(defaultValue || defaultSystemColor),
    _useState4 = _slicedToArray(_useState3, 2),
    correctColorValue = _useState4[0],
    setCorrectColorValue = _useState4[1];
  var _useState5 = useState('HEX'),
    _useState6 = _slicedToArray(_useState5, 2),
    currentColorType = _useState6[0],
    setCurrentColorType = _useState6[1];
  var _useState7 = useState(colorTypes),
    _useState8 = _slicedToArray(_useState7, 2),
    colTypeArr = _useState8[0],
    setColTypeArr = _useState8[1];
  var _useState9 = useState(typeof visible === 'undefined' ? !!defaultOpen : !!visible),
    _useState10 = _slicedToArray(_useState9, 2),
    showPanel = _useState10[0],
    setShowPanel = _useState10[1];
  var _useState11 = useState(1),
    _useState12 = _slicedToArray(_useState11, 2),
    alpha = _useState12[0],
    setAlpha = _useState12[1];
  var _useState13 = useState(alpha * 100 + '%'),
    _useState14 = _slicedToArray(_useState13, 2),
    alphaNoVerifyVal = _useState14[0],
    setAlphaNoVerifyVal = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isFollow = _useState16[0],
    setIsFollow = _useState16[1];
  var _useState17 = useState(),
    _useState18 = _slicedToArray(_useState17, 2),
    clickedColorIndex = _useState18[0],
    setClickedColorIndex = _useState18[1];
  var colorPickerPrefixCls = getPrefixCls(prefixCls, 'color-picker');
  var popUpLayer = getPrefixCls(prefixCls, 'color-picker-pop');
  var containerCls = classNames("".concat(colorPickerPrefixCls, "-container"));
  var inputCls = classNames("".concat(colorPickerPrefixCls, "-input"), className);
  var inputRef = useRef(null);
  var showColorPickerPanel = showColorTransfer || typeof showPresetColor === 'boolean' && showPresetColor && (presetColor === null || presetColor === void 0 ? void 0 : presetColor.length) || typeof showPresetColor === 'undefined' || (functionalColor === null || functionalColor === void 0 ? void 0 : functionalColor.length) && showSwitch || (showColorPickerBox === null || showColorPickerBox === void 0 ? void 0 : showColorPickerBox.showBox) || (showColorPickerBox === null || showColorPickerBox === void 0 ? void 0 : showColorPickerBox.showHue) || (showColorPickerBox === null || showColorPickerBox === void 0 ? void 0 : showColorPickerBox.showOpacity);
  var setIconColor = function setIconColor(value) {
    value === functionalColorName ? setIsFollow(true) : setIsFollow(false);
    var inpValue = value === functionalColorName ? functionalColor : value;
    var inputValType = validateColor(inpValue);
    var setState = function setState(formatArr, correctColorValue, alpha, alphaStr) {
      setColTypeArr(formatArr);
      setCorrectColorValue(correctColorValue);
      setAlpha(alpha);
      setAlphaNoVerifyVal(alphaStr);
    };
    if (inputValType) {
      var formatArr = colorFormat(inpValue, strFixed(Color(getColorObj(inpValue)).alpha(), 2));
      setState(formatArr, formatArr[valOfCorrespondingType(currentColorType)].value, Color(getColorObj(inpValue)).alpha(), (strFixed(Color(getColorObj(inpValue)).alpha(), 2) * 100).toFixed() + '%');
      setClickedColorIndex(highlightPresetColorIndex(formatArr[0].value, presetColorToHEX(presetColor || systemPresetColor)));
    } else {
      var _formatArr = colorFormat(defaultSystemColor);
      setState(_formatArr, defaultSystemColor, 1, '100%');
    }
  };
  var handleChange = function handleChange(e) {
    setClickedColorIndex(-1);
    var inpValue = toLowerCase(e.target.value);
    if (value === undefined) {
      setIconColor(inpValue);
      setInputColorValue(inpValue);
    }
    var callback = function callback(val, alpha) {
      var formatArr = colorFormat(val, alpha);
      onChange && onChange(inpValue, formatArr);
    };
    if (validateColor(inpValue)) {
      callback(inpValue, alpha);
    } else {
      callback(defaultSystemColor, alpha);
    }
    functionalColor && showSwitch && setIsFollow(false);
  };
  var handleClick = function handleClick() {
    if (typeof visible === 'undefined') {
      setShowPanel(!showPanel);
    }
    onVisibleChange && onVisibleChange(!showPanel);
  };
  useEffect(function () {
    if (typeof visible !== 'undefined') {
      setShowPanel(visible);
    }
  }, [visible]);
  useEffect(function () {
    if (value) {
      setIconColor(value);
    } else {
      if (defaultValue) {
        setIconColor(defaultValue);
      }
    }
  }, [value, defaultValue]);
  var afterIcon = function afterIcon() {
    var _classNames;
    var afterIconContainerCls = classNames("".concat(colorPickerPrefixCls, "-icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(colorPickerPrefixCls, "-icon-underline"), borderType === 'underline'), _defineProperty(_classNames, "".concat(colorPickerPrefixCls, "-icon-bordered"), borderType === 'bordered'), _defineProperty(_classNames, "".concat(colorPickerPrefixCls, "-icon-up"), showPanel), _defineProperty(_classNames, "".concat(colorPickerPrefixCls, "-icon-down"), !showPanel), _classNames));
    return /*#__PURE__*/React.createElement("div", {
      className: afterIconContainerCls,
      style: {
        backgroundColor: "".concat(colTypeArr[2].value || defaultSystemColor)
      }
    }, showColorPickerPanel && /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down"
    }));
  };
  var colorInputEle = /*#__PURE__*/React.createElement("div", {
    className: containerCls,
    ref: inputRef
  }, /*#__PURE__*/React.createElement(Input, {
    borderType: borderType,
    placeholder: placeholder,
    value: value !== null && value !== void 0 ? value : inputColorValue,
    className: inputCls,
    onChange: handleChange,
    style: style,
    onClick: handleClick
  }), /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    className: "".concat(colorPickerPrefixCls, "-icon-container")
  }, suffixIcon && suffixIcon(colTypeArr[2].value) || afterIcon()));
  var panel = /*#__PURE__*/React.createElement(ColorPickerPanel
  // API
  , {
    // API
    showSwitch: showSwitch,
    showColorTransfer: showColorTransfer,
    showPresetColor: showPresetColor,
    showColorPickerBox: showColorPickerBox,
    functionalColor: functionalColor,
    functionalColorName: functionalColorName,
    switchName: switchName,
    presetColor: presetColor,
    value: value,
    visible: visible,
    showPanel: showPanel,
    onVisibleChange: onVisibleChange,
    // private
    setInputColorValue: setInputColorValue,
    setCorrectColorValue: setCorrectColorValue,
    correctColorValue: correctColorValue,
    clickedColorIndex: clickedColorIndex,
    setClickedColorIndex: setClickedColorIndex,
    onChange: onChange,
    alpha: alpha,
    setAlpha: setAlpha,
    alphaNoVerifyVal: alphaNoVerifyVal,
    setAlphaNoVerifyVal: setAlphaNoVerifyVal,
    isFollow: isFollow,
    setIsFollow: setIsFollow,
    setShowPanel: setShowPanel,
    inputRef: inputRef,
    colTypeArr: colTypeArr,
    setColTypeArr: setColTypeArr,
    currentColorType: currentColorType,
    setCurrentColorType: setCurrentColorType,
    showColorPickerPanel: showColorPickerPanel
  });
  var popperProps = _extends(_extends({}, colorPickerProps), {
    popperClassName: popUpLayer,
    placement: 'bottomLeft',
    defaultVisible: showPanel,
    visible: showPanel,
    onVisibleChange: null,
    clickToClose: false
  });
  return usePopper(colorInputEle, panel, popperProps);
};
ColorPicker.displayName = 'ColorPicker';
export default ColorPicker;